import {Injectable} from '@angular/core';
import {
  Address,
  CommandService,
  StateWithUser,
  UserAddressConnector,
  UserAddressService,
  UserIdService
} from '@spartacus/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {AddressIdentity} from '../../model/dcp-address-identity';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class DcpUserAddressService extends UserAddressService {

  private userAddressLoadedSuccessSubscription: Subscription = Subscription.EMPTY;
  private userAddressReadyToFetchSubscription: Subscription = Subscription.EMPTY;
  private userGetAddressesSubscription: Subscription = Subscription.EMPTY;
  private userAddressReadyToFetch$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    protected store: Store<StateWithUser>,
    protected userIdService: UserIdService, userAddressConnector: UserAddressConnector, commandService: CommandService,
  ) {
    super(store, userIdService, userAddressConnector, commandService);
  }

  /**
   * Simplifies Spartacus multi-step process for retrieving user address data into one subscription
   */
  public loadAndFetchAddresses(): Observable<Address[]> {
    const addressData: BehaviorSubject<Address[]> = new BehaviorSubject<Address[]>([]);
    this.loadAddresses();
    this.userAddressLoadedSuccessSubscription = this.getAddressesLoadedSuccess().pipe(filter(status => !!status), untilDestroyed(this)).subscribe((status) => {
      this.userAddressReadyToFetch$.next(status);
    });
    this.userAddressReadyToFetchSubscription = this.userAddressReadyToFetch$.pipe(filter(status => !!status), untilDestroyed(this)).subscribe((status) => {
      this.userGetAddressesSubscription = this.getAddresses().pipe(filter(addresses => !!addresses.length), untilDestroyed(this)).subscribe((addresses: Address[]) => {
        addressData.next(addresses);

        this.userAddressLoadedSuccessSubscription.unsubscribe();
        this.userAddressReadyToFetchSubscription.unsubscribe();
        this.userGetAddressesSubscription.unsubscribe();
      });
    });
    return addressData;
  }

  //used to avoid using null/undefined query parameters update cart address backend calls
  public getAddressIdentity(address: Address): AddressIdentity {
    return {
      addressUid: address.sapAddressUUID || '',
      externalAddressNumber: address.externalAddressNumber || '',
      addressPk: address.id || ''
    };
  }

}
